import { createMixpanelInstance } from '@revbox/tracking'
import { isCookiesEnabled } from '../contexts/CookiesContext'

const token = process.env.REACT_APP_MIXPANEL_TOKEN

const instance = createMixpanelInstance({
    token,
    isCookiesEnabled
})

export const mixpanelInstance = instance
